import styled from 'styled-components';
import {
  display,
  alignItems,
  justifyContent,
  flexWrap,
  flexDirection,
  boxShadow,
  color,
  space,
  borderRadius,
  width,
  height
} from 'styled-system';

const NavbarStyle = styled.nav`
  
  
  
  /* Style system supported prop */
  ${display}
  ${alignItems}
  ${justifyContent}
  ${flexDirection}
  ${flexWrap}
  ${width}
  ${height}
  ${color}
  ${space}
  ${boxShadow}
  ${borderRadius}


  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 12px 0 !important;

  .main-logo{
    img{
      width: 100px;
      max-width: 100px;
    }
  }
  .logo-alt{
    img{
      width: 100px;
      max-width: 100px;
    }
  }
  .container{
    padding: 0 15px!important;
    width:100%;

    .right-side{
      margin-left: 30px;
      width: 100%;
      display:flex;
      justify-content: flex-end;
    }
  }

  @media (min-width: 576px) { 

    .main-logo{
      img{
        width: 120px;
        max-width: 120px;
      }
    }
    .logo-alt{
      img{
        width: 120px;
        max-width: 120px;
      }
    }

   }

@media (min-width: 768px) { 
  .main-logo{
    img{
      width: 150px;
      max-width: 150px;
    }
  }
  .logo-alt{
    img{
      width: 150px;
      max-width: 150px;
    }
  }

}

@media (min-width: 992px) {
  
  .main-logo{
    img{
      width: 180px;
      max-width: 180px;
    }
  }
  .logo-alt{
    img{
      width: 180px;
      max-width: 180px;
    }
  }
  .container{
    .right-side{
      justify-content: space-between;
   margin-top:11px;

    }
  }

  
 }

`;

NavbarStyle.displayName = 'NavbarStyle';

export default NavbarStyle;
